// @flow strict

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

// Components
import ReportGenerationSystemMFE from 'microfrontends/ReportGenerationSystem';
import { QuickNavigatorObservable } from 'components/_FrontendObservables';

// Types
import type { IntlType, HistoryType } from 'types';

// Services
import { selectAllClients } from 'services/Client/selectors';
import { fetchAllClients } from 'services/Client/thunks';

type Props = {
    intl: IntlType,
    history: HistoryType,
    match: {
        params: {
            plantId: string,
        },
    },

    clients: ImmutableList<ImmutableClient>,
    fetchAllClients: () => void, // for navigation.
};

export class ReportGenerationSystem extends React.PureComponent<Props, null> {
    componentDidMount() {
        // for navigation.
        if (this.props.clients.isEmpty()) {
            this.props.fetchAllClients();
        }

        QuickNavigatorObservable.setQuickNavigatorSolvExtract();

    }

    componentWillUnmount() {
        QuickNavigatorObservable.removeQuickNavigator()
    }

    getPlantId() {
        const plantId = this.props.match.params.plantId;
        if (plantId) {
            return parseInt(plantId, 10);
        }
        return null;
    }

    render() {
        const plantId = this.getPlantId();
        if (plantId) {
            return <ReportGenerationSystemMFE history={this.props.history} plantId={plantId} />;
        } else {
            return (
                <React.Fragment>
                    {this.props.intl.formatMessage({
                        id: 'views.ReportGenerationSystem.badPlantIdProvided',
                    })}
                </React.Fragment>
            );
        }
    }
}

const mapStateToProps = () =>
    createStructuredSelector({
        clients: selectAllClients(),
    });

    const mapDispatchToProps = (dispatch: ReduxDispatch) =>
        bindActionCreators(
            {
                fetchAllClients,
            },
            dispatch
        );

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(injectIntl(ReportGenerationSystem))
);
